// extracted by mini-css-extract-plugin
module.exports = {"comp":"CardC_comp__7skm_"};